<template>
  <div>
    <Header name="ESTOQUE DE RAÇÃO" />

    <div class="feed-inventory-page-shell">
      <div class="maxcontainer container">
        <ol class="breadcrumb">
          <li v-if="!feedInventoryOnly" class="breadcrumb-item">
            <router-link to="/home-page">Home</router-link>
          </li>
          <li class="breadcrumb-item active">{{ breadcrumbLabel }}</li>
        </ol>

        <div class="page-animation">
          <FeedInventoryPage view-all-barns />
        </div>
      </div>

      <Copyright />
    </div>
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Copyright from '../components/Copyright.vue'
import FeedInventoryPage from '../components/FeedInventoryPage.vue'
import { isFeedInventoryOnly, resolveFeedInventoryAccess } from '../utils/feedInventoryAccess'

export default {
  name: 'FeedInventoryAllBarnsPage',
  components: {
    Header,
    Copyright,
    FeedInventoryPage
  },
  beforeRouteEnter(to, from, next) {
    to.meta.title = 'PecSmart - Estoque de Ração'
    document.title = to.meta.title
    next()
  },
  created() {
    if (this.$store.getters.getLogedIn === false) {
      this.$router.push('/')
      return
    }

    if (!this.canAccessFeedInventory) {
      this.$router.push('/home-page')
    }
  },
  computed: {
    feedInventoryAccess() {
      return resolveFeedInventoryAccess(
        this.$store.getters.getCurrentUser,
        this.$store.getters.getCompanySettings,
      )
    },
    canAccessFeedInventory() {
      return this.feedInventoryAccess.allowed
    },
    breadcrumbLabel() {
      const pks = this.feedInventoryAccess.farmPks
      if (pks && pks.length > 1) return `Estoque de ração — granjas ${pks.join(', ')}`
      if (pks && pks.length === 1) return 'Estoque de ração — sua granja'
      return 'Estoque de ração — todos os galpões'
    },
    feedInventoryOnly() {
      return isFeedInventoryOnly(
        this.$store.getters.getCurrentUser,
        this.$store.getters.getCompanySettings,
      )
    }
  }
}
</script>

<style scoped>
.feed-inventory-page-shell {
  background: #f3f4f6;
  min-height: calc(100vh - 70px);
  padding-bottom: 24px;
  overflow-x: hidden;
}

.page-animation {
  animation: down 0.4s ease;
}

@keyframes down {
  0% { opacity: 0; }
  100% { opacity: 1; }
}
</style>
